import React from 'react';
import firebase from 'firebase/compat/app';
import Logo from './mutual-logo.png';
import './NoAccountRedirectionPage.css';
import { Grid } from '@mui/material';
export const parentDiv = {
    display: 'flex',
    flexDirection: 'column' as 'column',
    padding: '5px',
    childAlign: 'middle',
    marginTop: '6rem',
}

export const textStyle = {
	textAlign: 'center' as 'center', 
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '29px',
    color: '#6D6E71',
    marginBottom: '2em',
    marginTop: '1em'
}

export const imgStyle = {height: '30vh'}

export const imgWrapperGrid = {margin: '0 auto 0 auto'}

export const backLoginBtnStyle = {
    width: '325px',
    height: '46px',
    margin: 'auto',
    marginBottom: '1em',
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1px 10px 1px 1px',
    background: '#FFFFFF',
    border: '1px solid #38ABFF',
    boxSizing: 'border-box' as 'border-box',
    borderRadius: '15px',
    flex: 'none',
    order: '0',
    flexGrow: '0',
}


interface props {
	setIsLogged: any;
	setMobileLogin: any;
}



const NoAccountRedirectionPage : React.FC<props> = (props) => {

		return (
			<Grid container item style={parentDiv}>
				<Grid item style={imgWrapperGrid}>
					<img style={imgStyle} src={Logo} alt={'Mutual_App_Logo'} />
				</Grid>

				<h1 style={textStyle}>Download the Mutual App to Sign Up For a Free Account Today</h1>
				<h1 style={textStyle}>
					<a href={'https://www.mutual.app/'}>Get The App</a>
				</h1>
				<Grid
					// id={'signout-button-holder'}
					style={backLoginBtnStyle}
					onClick={(): any =>
						firebase
							.auth()
							.signOut()
							.then(() => {
								props.setIsLogged(false);
								props.setMobileLogin(false);
							})
					}
				>
					<p id={'signout-button-text'}>Back to Login Screen</p>
				</Grid>
			</Grid>
		);
}

export default NoAccountRedirectionPage;
